<div class="dep-modal">
  <div class="dep-modal__header">
    <h3>{{ 'builderScreen.searchDependency.title' | translateTA }}</h3>
    <p>
      Defina quais campos devem ser preenchidos antes deste campo ser habilitado.
      Para campos de pesquisa, a coluna de filtro permite filtrar os resultados automaticamente.
    </p>
  </div>

  <nz-input-group [nzPrefix]="searchIcon" nzSize="small" class="dep-modal__search">
    <input nz-input [(ngModel)]="searchText" [placeholder]="'builderScreen.searchDependency.searchPlaceholder' | translateTA" />
  </nz-input-group>
  <ng-template #searchIcon><nz-icon nzType="search"></nz-icon></ng-template>

  <div class="dep-modal__body" *ngIf="filteredGroups.length > 0">
    <nz-collapse [nzBordered]="false" nzGhost>
      <nz-collapse-panel
        *ngFor="let group of filteredGroups; trackBy: trackByType"
        [nzActive]="group.expanded"
        [nzHeader]="groupHeaderTpl"
        [nzExtra]="groupExtraTpl">

        <ng-template #groupHeaderTpl>
          <div class="dep-group-title">
            <nz-tag [nzColor]="group.color" class="dep-group-title__tag">{{ group.label }}</nz-tag>
            <span class="dep-group-title__count">{{ group.items.length }}</span>
          </div>
        </ng-template>

        <ng-template #groupExtraTpl>
          <nz-badge *ngIf="getCheckedCount(group) > 0"
            [nzCount]="getCheckedCount(group)"
            [nzStyle]="{ backgroundColor: '#1890ff' }">
          </nz-badge>
        </ng-template>

        <div class="dep-item" *ngFor="let item of group.items; trackBy: trackByDataPath"
          [class.dep-item--active]="item.checked">

          <div class="dep-item__row">
            <label nz-checkbox [(ngModel)]="item.checked" (ngModelChange)="onItemToggled(item)">
              <span class="dep-item__label">{{ item.field.label }}</span>
            </label>
            <code class="dep-item__path">{{ item.field.dataPath }}</code>
          </div>

          <div class="dep-item__config" *ngIf="item.checked" @slideDown>
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzNoColon>
                Coluna de filtro
                <span class="dep-item__optional">opcional</span>
                <nz-icon nzType="info-circle" nz-tooltip
                  [nzTooltipTitle]="'builderScreen.searchDependency.filterHelp' | translateTA"
                  class="dep-item__help-icon"></nz-icon>
              </nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input nz-input [(ngModel)]="item.filterColumn" [placeholder]="'builderScreen.searchDependency.fieldPlaceholder' | translateTA" nzSize="small" />
              </nz-form-control>
            </nz-form-item>

            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzNoColon>{{ 'builderScreen.searchDependency.emptyMessage' | translateTA }}</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input nz-input [(ngModel)]="item.requiredMessage"
                  [placeholder]="'Selecione ' + item.field.label + ' primeiro'" nzSize="small" />
              </nz-form-control>
            </nz-form-item>

            <label nz-checkbox [(ngModel)]="item.clearOnChange" class="dep-item__clear">
              Limpar valor quando o campo dependente mudar
            </label>
          </div>
        </div>

      </nz-collapse-panel>
    </nz-collapse>
  </div>

  <nz-empty *ngIf="items.length === 0"
    [nzNotFoundContent]="'builderScreen.searchDependency.noFields' | translateTA">
  </nz-empty>
  <nz-empty *ngIf="items.length > 0 && filteredGroups.length === 0"
    [nzNotFoundContent]="'builderScreen.searchDependency.noResults' | translateTA">
  </nz-empty>

  <nz-divider></nz-divider>

  <div class="dep-modal__footer">
    <span class="dep-modal__footer-info" *ngIf="selectedCount > 0">
      {{ selectedCount }} dependência(s)
    </span>
    <button nz-button nzType="default" (click)="handleCancel()">Cancelar</button>
    <button nz-button nzType="primary" (click)="handleOk()">Salvar</button>
  </div>
</div>
